'use strict';

module.exports = require('./is-implemented')()
	? Math.sign
	: require('./shim');
